import { demoFile, component } from 'system/demo';
import { AddComment, Chat } from '@carbon/icons-react';
import { ModDashboardSidebar, ModDashboardHomeScreen } from 'open-modules/zdf/structure/moddashboard';

const modDashboardDemoData = {
  modulePublicQuestion: {
    thread1: { key: 't1', from: 'a', question: 'Q1', time: Date.now() },
    thread2: { key: 't2', from: 'b', question: 'Q2', time: Date.now() - 1000 },
  },
  modTaskQueues: { thread1: {}, thread2: {} },
  modTaskSubQueues: {
    thread1: { awaiting_decision: {}, human_approved: {}, auto_approved: {}, rejected: {} },
    thread2: { awaiting_decision: {}, human_approved: {}, auto_approved: {}, rejected: {} },
  },
  threadQueueCounts: {},
  serverCalls: {},
};

demoFile('open-modules/zdf/structure/moddashboard');

component('ModDashboardSidebar', ModDashboardSidebar, {
  state: {},
  config: {
    moderationPages: [
      { id: 'page-threads', label: '!First', icon: AddComment, component: () => null },
      { id: 'page-comments', label: '!Second', icon: Chat, component: () => null },
    ],
    defaultModerationPage: { id: 'page-comments', label: '!Second', icon: Chat, component: () => null },
  },
});

